import { openBlock, createElementBlock, normalizeClass, pushScopeId, popScopeId, createElementVNode } from "vue";
/* empty css                  */
import _export_sfc from "../uikit._virtual/_plugin-vue_export-helper.es.js";
const _sfc_main = {
  name: "uikit-cross-icon",
  props: {
    type: {
      type: String,
      validator(value) {
        return ["close", "default", "add"].includes(value);
      },
      default: "default"
    }
  },
  computed: {
    crossIconClass() {
      return {
        [`uikit-cross-icon-${this.type}`]: true
      };
    }
  }
};
const _withScopeId = (n) => (pushScopeId("data-v-09034bea"), n = n(), popScopeId(), n);
const _hoisted_1 = /* @__PURE__ */ _withScopeId(() => /* @__PURE__ */ createElementVNode("path", {
  d: "M16.5869 14.1591C17.4276 15.038 17.4276 16.4618 16.5869 17.3407C15.7457 18.2201 14.384 18.2194 13.5436 17.3407L8.6087 12.1815L3.67381 17.3407C2.83263 18.2201 1.47095 18.2194 0.630521 17.3407C-0.210174 16.4618 -0.210174 15.038 0.630521 14.1591L5.56541 8.99993L0.630521 3.84079C-0.210174 2.96189 -0.210174 1.53809 0.630521 0.65918C1.47121 -0.219727 2.83311 -0.219727 3.67381 0.65918L8.6087 5.81832L13.5436 0.65918C14.3843 -0.219727 15.7462 -0.219727 16.5869 0.65918C17.4276 1.53809 17.4276 2.96189 16.5869 3.84079L11.652 8.99993L16.5869 14.1591Z",
  fill: "currentColor"
}, null, -1));
const _hoisted_2 = [
  _hoisted_1
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", {
    width: "18",
    height: "18",
    viewBox: "0 0 18 18",
    stroke: "none",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    class: normalizeClass($options.crossIconClass)
  }, _hoisted_2, 2);
}
const UikitCrossIcon = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__scopeId", "data-v-09034bea"]]);
export {
  UikitCrossIcon as default
};
//# sourceMappingURL=CrossIcon.vue.es.js.map
